import React, { Component } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';

const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplayHoverPause: true,
    autoplay: true,
    animateOut: 'slideOutDown',
    animateIn: 'flipInX',
    items: 1,
    navText: [
        "<i className='fas fa-chevron-left'></i>",
        "<i className='fas fa-chevron-right'></i>"
    ]
}

class TopPanel extends Component {
    state = { 
        display: false,
        panel: true
    };

    componentDidMount(){ 
        this.setState({ display: true }) 
    }

    render() {
        let { panel } = this.state;
        return (
            <div className={`top-panel ${panel ? '' : 'hide'}`}>
                <div className="container">
                    <div className="panel-content">
                        {this.state.display ? <Slider 
                            className="top-panel-slides"
                            {...options}
                        >
                            <div className="single-item-box">
                                <p><strong>Enjoy an extra 20% off</strong> select sales styles <Link href="#"><a>Read More</a></Link></p>
                            </div>

                            <div className="single-item-box">
                                <p><strong>Enjoy an extra 20% off</strong> select sales styles <Link href="#"><a>Read More</a></Link></p>
                            </div>

                            <div className="single-item-box">
                                <p><strong>Enjoy an extra 20% off</strong> select sales styles <Link href="#"><a>Read More</a></Link></p>
                            </div>
                        </Slider> : ''}
                        <i onClick={() => this.setState({panel: false})} className="fas fa-times panel-close-btn"></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default TopPanel;
